<template>
  <div>
    <transition name="scale-in" appear>
      <div class="v-modal-page" v-if="true">
        <div class="error-card-content">
          <div><VSpinner /></div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script setup lang="ts">
import VSpinner from "../components/VSpinner.vue";
</script>
<style>
.error-card {
  background-color: white;
  width: 280px;
  padding: 20px;
  border-radius: 8px;
  box-shadow: rgb(0 0 0 / 20%) 0px 17.5px 70px;
  flex-direction: column;
  display: flex;
}
.error-card-content {
  margin: auto;
  display: flex;
  flex-direction: row;
  width: fit-content;
  padding: 0px 0px 10px 0px;
}
.error-messages {
  margin: auto;
}
</style>
